import React from "react";
import type { FC } from "react";
import UtilityPanel from "../layout/UtilityPanel";
import CorePanelFooter from "../layout/CorePanelFooter";
import CoreLayout from "../layout/CoreLayout";
import Button from "../form/Button";
import { IconNewWindowLg, IconCaution } from "../icons";
import iconPge from "../../assets/icon-pge.png";
import { useModal } from "../../hooks/useModal";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../store/appStore";
import { withErrorBoundary } from "../components/withErrorBoundary";

interface Props {
	cancelSession: () => void;
}

const LoginError: FC<Props> = (props) => {
	const { setSessionStatus } = useAppStore();
	const { showModal } = useModal();
	const header = (
		<div className="self-stretch inline-flex justify-start items-center gap-3">
			<IconCaution />
			<div className="flex-1 justify-start font-normal font-['Inter']">
				<div className="text-king-red text-base">
					We're unable to access your PG&E account.
				</div>
				<div className="text-king-red text-xs font-normal">
					Your username or password may be invalid.
				</div>
			</div>
			<img className="w-11 h-12" src={iconPge} />
		</div>
	);

	function onBack() {
		props.cancelSession();
		setSessionStatus('LOGIN_WAITING')
	}

	return (
        <CoreLayout>
            <UtilityPanel headerOverride={header}>
                <div className="grid gap-4">
                    <div className="self-stretch flex flex-col justify-start items-start gap-1">
                        <div className="justify-start text-black text-xs font-normal font-['Inter']">
                            Would you like to try again with a different
                            username or password?
                        </div>
                        <Button
                            onClick={onBack}
                            type="secondary"
                            className="w-[200px]"
                        >
                            Go Back
                        </Button>
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-1">
                        <div className="justify-start text-black text-xs font-normal font-['Inter']">
                            Don't remember your pge.com password?
                        </div>
                        <Button
                            onClick={() => {
                                window.open(
                                    "https://pge.com/eimp/?appname=MyAccount&returnURL=https%3A%2F%2Fm.pge.com#forgotPassword",
                                    "_blank"
                                );
                            }}
                            type="secondary"
                            subType="outline"
                            className="min-w-[200px]"
                        >
                            Reset password <IconNewWindowLg />
                        </Button>
                    </div>
                    <div className="self-stretch h-16 flex flex-col justify-start items-start gap-1">
                        <div className="justify-start text-black text-xs font-normal font-['Inter']">
                            Don't remember your pge.com username?
                        </div>
                        <Button
                            onClick={() => {
                                window.open(
                                    "https://pge.com/eimp/?appname=MyAccount&returnURL=https%3A%2F%2Fm.pge.com#forgotUserName",
                                    "_blank"
                                );
                            }}
                            type="secondary"
                            subType="outline"
                            className="min-w-[200px]"
                        >
                            Retrieve username <IconNewWindowLg />
                        </Button>
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-1">
                        <div className="justify-start text-black text-xs font-normal font-['Inter']">
                            Don't have a pge.com account?
                        </div>
                        <Button
                            onClick={() => {
                                window.open(
                                    "https://m.pge.com/#registration",
                                    "_blank"
                                );
                            }}
                            type="secondary"
                            subType="outline"
                            className="min-w-[200px]"
                        >
                            Create account <IconNewWindowLg />
                        </Button>
                    </div>
                </div>
            </UtilityPanel>
            <CorePanelFooter>
                <Button
                    onClick={() =>
                        showModal(
                            "cancel",
                            "Are you sure you want to cancel?",
                            "Cancelling will end the authorization process.",
                            props.cancelSession
                        )
                    }
                    type="primary"
                    subType="outline"
                >
                    Cancel
                </Button>
            </CorePanelFooter>
        </CoreLayout>
    );
};

export default withErrorBoundary(LoginError);
